import { render, staticRenderFns } from "./lk-filter.vue?vue&type=template&id=68020e69&"
import script from "./lk-filter.vue?vue&type=script&lang=js&"
export * from "./lk-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-filter/lk-filter.vue
// module id = 88
// module chunks = 0